<template>
    <div>
        <div class="banner location-bn">
            <img src="@/assets/images/banner9.png" alt="">
            <h2 class="title">Location｜好喝好玩的在這裡</h2>
        </div>
        <div class="wrap">
            <section id="tabs-block" class="section">
                <ul class="text-center">
                    <li>
                        <router-link :to="{name: 'location'}" class="tabs-item">
                            <div class="name">地標<br>介紹</div>
                            <p>Landmark</p>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'location'}" class="tabs-item">
                            <div class="name">商家<br>介紹</div>
                            <p>Store</p>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'location'}" class="tabs-item">
                            <div class="name">所有<br>地點</div>
                            <p>All Location</p>
                        </router-link>
                    </li>
                </ul>
            </section>
            <section class="page-section section">
                <div class="row">
                    <div class="col col2">
                        <div class="gallery-slick">
                            <div class="gallery-main">
                                <div v-for="(img,idx) in images_url" :key="idx" :class="idx == 0 ? 'active' : ''" class="gallery-item" :style="{backgroundImage: 'url(' + img + ')' }"></div>
                            </div>
                            <div class="gallery-nav">
                                <a v-for="(img,idx) in images_url" :key="idx" :class="idx == 0 ? 'active' : ''" href="javascript:void(0);" class="gallery-item" :style="{backgroundImage: 'url(' + img + ')' }"></a>
                            </div>
                        </div>
                    </div>
                    <div class="col col2">
                        <div class="intro" style="white-space: pre-line;">
                            <h2>{{ locationPage_list.title }}</h2>
                            {{ locationPage_list.content }}
                        </div>
                    </div>
                </div>
                <div class="content">
                    <h3 class="title"><span>所有地點</span></h3>
                    <ul class="link-group">
                        <li v-for="other in locationPage_other" :key="other.id">
                            <router-link :to="{path: `/locationPage/${other.id}`}">
                                <span class="name">
                                    {{ other.title }}
                                </span>
                                <span class="text">
                                    {{ other.content }}
                                </span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'locationPage',
    data () {
        return {
            locationPage_list: '',
            images_url: '',
            locationPage_other: '',
        }
    },
    beforeMount: function () {
        const formData = new FormData();
        formData.append('CMD', 'LocationPage');
        formData.append('environment_id', this.$route.params.id);
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
        .then(response => {
            // console.log(response);
            if (response.data.result == false) {
                console.log('LocationPage: Server Error');
            }else {
                const get_list = response.data.locationPage_list;
                const get_imgs = response.data.images_url;
                const get_other = response.data.locationPage_other;
                this.locationPage_list = get_list;
                this.images_url = JSON.parse(get_imgs);
                this.locationPage_other = get_other;
            }
        })
        .catch(error => {
            console.log(error);
        })
    },
    methods: {
        get_list (id) {
            const formData = new FormData();
            formData.append('CMD', 'LocationPage');
            formData.append('environment_id', id);
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
            .then(response => {
                if (response.data.result == false) {
                    console.log('LocationPage: Server Error');
                }else {
                    const get_list = response.data.locationPage_list;
                    const get_imgs = response.data.images_url;
                    const get_other = response.data.locationPage_other;
                    this.locationPage_list = get_list;
                    this.images_url = JSON.parse(get_imgs);
                    this.locationPage_other = get_other;
                }
            })
            .catch(error => {
                console.log(error);
            })
        }
    },
    mounted: function() {
        var gallery = $('.gallery-slick');
        gallery.find(".gallery-nav").on("click", ".gallery-item", function (e) {
            e.preventDefault();
            var _idx = gallery.find(".gallery-nav .gallery-item").index($(this));
            $(this).addClass("active").siblings().removeClass("active");
            gallery.find(".gallery-main .gallery-item").eq(_idx).addClass("active").siblings().removeClass("active");
        });
    },
    watch: {
        $route (e) {
            const goto_page = e.params.id
            this.get_list (goto_page);
        }
    }
};
</script>

<style>

</style>
